jQuery(function ($) {
    /**
     * Advance Taxonomy terms
     */
    $('.advance-taxonomy-terms-list-item').on('click', 'button.show-children', function (evt) {
        evt.stopImmediatePropagation();
        $(this).toggleClass('is-expanded').parent().next().slideToggle();
    });

});